import type { FC, HTMLAttributes, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode
}

export const Container: FC<ContainerProps> = ({ children, className, ...rest }): ReactNode => {
    return (
        <div className={cn('mx-auto w-full max-w-[1440px] px-5 sm:px-8 lg:px-12', className)} {...rest}>
            {children}
        </div>
    )
}
